
import ToggleOn from "../../../assets/filled/ToggleOn.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ToggleOnIcon({ className, dataTestid = "ToggleOnIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ToggleOn data-testid={dataTestid} className={classes} {...rest} />
  );
}
